import { useState } from 'react'

import styles from './controls.module.scss'

type SeriesStepperProps = {
  value: number
  min: number
  max: number
  onChange: (value: number) => void
  decLabel: string
  incLabel: string
  disabled?: boolean
  step?: number
  editable?: boolean
  normalize?: (n: number) => number
  inputLabel?: string
}

export const SeriesStepper = ({
  value,
  min,
  max,
  onChange,
  decLabel,
  incLabel,
  disabled = false,
  step = 1,
  editable = false,
  normalize,
  inputLabel,
}: SeriesStepperProps) => {
  const [draft, setDraft] = useState<string | null>(null)

  const commit = () => {
    if (draft === null) return
    setDraft(null)
    if (draft.trim() === '' || Number.isNaN(Number(draft))) return
    const next = Math.min(max, Math.max(min, (normalize ?? ((n) => n))(Number(draft))))
    if (next !== value) onChange(next)
  }

  return (
    <div className={styles.stepper}>
      <button
        type='button'
        className={styles.sq}
        aria-label={decLabel}
        disabled={disabled || value <= min}
        onClick={() => onChange(Math.max(min, value - step))}>
        −
      </button>
      {editable ? (
        <input
          type='text'
          inputMode='numeric'
          className={styles.stepInput}
          aria-label={inputLabel}
          disabled={disabled}
          value={draft ?? String(value)}
          onChange={(e) => setDraft(e.target.value.replace(/\D/g, ''))}
          onBlur={commit}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
              commit()
            }
          }}
        />
      ) : (
        <span className={styles.stepValue}>{value}</span>
      )}
      <button
        type='button'
        className={styles.sq}
        aria-label={incLabel}
        disabled={disabled || value >= max}
        onClick={() => onChange(Math.min(max, value + step))}>
        +
      </button>
    </div>
  )
}
